export const isPartnersEnv = !!process.env.REACT_APP_IS_PARTNERS_ENV;
export const isGoGameEnv = !isPartnersEnv;

export const isProductMadnessEnv = process.env.REACT_APP_NAME_ID === 'pm';
export const isPlariumEnv = process.env.REACT_APP_NAME_ID === 'pl';

export const googleAuthEnabled = !!parseInt(
  process.env.REACT_APP_GOOGLE_AUTH_ENABLED,
  10
);
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const isDevEnv = !!process.env.REACT_APP_IS_DEV_ENV;
